import { SDSLoaderProps } from "@politiet/sheriff-web-components";

export default function Loader({ size = "md", ...props }: SDSLoaderProps) {
  //TODO er det alltid riktig å skjule loader for skjermleser?🤔 https://aksel.nav.no/god-praksis/artikler/413-statusbeskjeder
  return <sds-loader size={size} {...props} aria-hidden="true" />;
}
